// Structure List
const STRUCTURE_REQUEST_LIST = 'STRUCTURE_REQUEST_LIST';
const STRUCTURE_SUCCESS_LIST = 'STRUCTURE_SUCCESS_LIST';
const STRUCTURE_FAILURE_LIST = 'STRUCTURE_FAILURE_LIST';


// FACILITY Getby Id
const STRUCTURE_REQUEST_GETBYID = 'STRUCTURE_REQUEST_GETBYID';
const STRUCTURE_SUCCESS_GETBYID = 'STRUCTURE_SUCCESS_GETBYID';
const STRUCTURE_FAILURE_GETBYID = 'STRUCTURE_FAILURE_GETBYID';

//Update
const STRUCTURE_REQUEST_UPDATE = 'STRUCTURE_REQUEST_UPDATE';
const STRUCTURE_SUCCESS_UPDATE = 'STRUCTURE_SUCCESS_UPDATE';
const STRUCTURE_FAILURE_UPDATE = 'STRUCTURE_FAILURE_UPDATE';

//ADD
const STRUCTURE_REQUEST_ADD = 'STRUCTURE_REQUEST_ADD';
const STRUCTURE_SUCCESS_ADD = 'STRUCTURE_SUCCESS_ADD';
const STRUCTURE_FAILURE_ADD = 'STRUCTURE_FAILURE_ADD';

//DELETE

const STRUCTURE_REQUEST_DELETE = 'STRUCTURE_REQUEST_DELETE';
const STRUCTURE_SUCCESS_DELETE = 'STRUCTURE_SUCCESS_DELETE';
const STRUCTURE_FAILURE_DELETE = 'STRUCTURE_FAILURE_DELETE';

//UpdateCONTACT
const STRUCTURE_REQUEST_CONTACTUPDATE = 'STRUCTURE_REQUEST_CONTACTUPDATE';
const STRUCTURE_SUCCESS_CONTACTUPDATE = 'STRUCTURE_SUCCESS_CONTACTUPDATE';
const STRUCTURE_FAILURE_CONTACTUPDATE = 'STRUCTURE_FAILURE_CONTACTUPDATE';


//PreviousId

const STRUCTURE_PREV_ID = "STRUCTURE_PREV_ID";

export {
    STRUCTURE_REQUEST_LIST,STRUCTURE_SUCCESS_LIST,STRUCTURE_FAILURE_LIST,
    STRUCTURE_REQUEST_GETBYID,STRUCTURE_SUCCESS_GETBYID,STRUCTURE_FAILURE_GETBYID,
    STRUCTURE_REQUEST_UPDATE,STRUCTURE_SUCCESS_UPDATE,STRUCTURE_FAILURE_UPDATE,
    STRUCTURE_REQUEST_ADD,STRUCTURE_SUCCESS_ADD,STRUCTURE_FAILURE_ADD,
    STRUCTURE_REQUEST_DELETE,STRUCTURE_SUCCESS_DELETE,STRUCTURE_FAILURE_DELETE,
    STRUCTURE_REQUEST_CONTACTUPDATE,STRUCTURE_SUCCESS_CONTACTUPDATE,STRUCTURE_FAILURE_CONTACTUPDATE,
    STRUCTURE_PREV_ID
};